/* eslint-disable import/first */
import React from 'react';
import { Button, Paper, Grid, Typography } from '@material-ui/core';
import { useNavigate, useLocation } from '@reach/router';
import thankyou from './images/thankyou.svg';
import css from './index.module.scss';
import { FormattedMessage, useIntl } from 'react-intl';

const FeedbackPopup = ({ showThankyou = false, onDrawerHandling, smileIndex }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const smileRate = location?.state?.smileRating || smileIndex;
  const intl = useIntl();
  const closeHandler = () => {
    if (location.pathname === `/${intl.locale}/feedback/sent`) {
      navigate(`/${intl.locale}/home`, { replace: true });
    }
    if (onDrawerHandling) {
      onDrawerHandling();
    }
  };

  return (
    <Paper variant="outlined" square className={css.drawerBoundry}>
      <Grid className={css.flexBox}>
        <img src={''} alt="" />
      </Grid>
      <Grid className={css.DrawerData}>
        <Grid className={css.tnxImgProp}>
          <img src={thankyou} />
        </Grid>
        <Grid>
          <Typography className={css.feedbackHeading}>
            {smileRate === -1 || showThankyou ? (
              <FormattedMessage id="thanks_for_feedback" defaultMessage="Thanks For Feedback" />
            ) : (
              <FormattedMessage id="thanks_for_rating" defaultMessage="Thanks For Rating Us" />
            )}
          </Typography>
        </Grid>
        {!smileRate || smileRate < 3 ? (
          <Grid className={css.tnxTypography}>
            <Typography className={css.typography}>
              <FormattedMessage
                id="value_feedback1"
                defaultMessage="We value your feedback, we will try to"
              />
              <br />
              <FormattedMessage
                id="value_feedback2"
                defaultMessage="improve our service. Hope you have a better"
              />
              <br />
              <FormattedMessage id="value_feedback3" defaultMessage="experience next time!" />
            </Typography>
          </Grid>
        ) : (
          ''
        )}
        <Grid className={css.buttonArea}>
          <Button className={css.tnxButton} onClick={closeHandler}>
            <FormattedMessage id="gotit" defaultMessage="GOT IT" />
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FeedbackPopup;
